export default __webpack_public_path__ + "static/analysts_Debater_ENTP_conclusion-8af39cad1d39c0507af678f6480a43df.svg";